import avatarModule from '../avatarModule';

function avatarTypeService() {
  'ngInject';

  return {
    assetTypeLookup: {},
    assetTypeNameLookup: {},

    setAssetTypeLookups(wearableAssetTypes) {
      for (let i = 0; i < wearableAssetTypes.length; i++) {
        let assetType = wearableAssetTypes[i];
        this.assetTypeLookup[assetType.id] = assetType;
        this.assetTypeNameLookup[assetType.name] = assetType;
      }
    },

    getAssetTypeName(id) {
      let assetType = this.assetTypeLookup[id];
      return assetType && assetType.name ? assetType.name : null;
    },

    getAssetTypeByName(name) {
      let assetType = this.assetTypeNameLookup[name];
      return assetType;
    }
  };
}

avatarModule.factory('avatarTypeService', avatarTypeService);

export default avatarTypeService;
